import { motion } from "framer-motion";
import { Building2, Compass, Globe2 } from "lucide-react";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="section relative bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5"
        >
          <div className="relative rounded-2xl overflow-hidden border border-white/10">
            <img
              src="https://images.pexels.com/photos/5414582/pexels-photo-5414582.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=940"
              alt="Mumbai financial district at night"
              className="w-full h-[520px] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/80 via-black/20 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 glass-strong rounded-xl p-5">
              <div className="text-[10px] tracking-[0.3em] text-[#D4AF37] uppercase">Headquartered in</div>
              <div className="font-display text-2xl font-bold text-white mt-1">Mumbai, India</div>
              <div className="text-sm text-gray-400 mt-1">Serving clients across India & NRIs globally</div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <p className="text-xs tracking-[0.35em] uppercase text-[#D4AF37]">About Axomind</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-white mt-4 leading-[1.05] tracking-tight">
            Built on research.
            <br />
            <span className="text-gold-gradient">Anchored in trust.</span>
          </h2>
          <p className="mt-6 text-gray-300 text-base lg:text-lg leading-relaxed">
            Axomind Asset Services LLP is an AMFI Registered Mutual Fund Distributor (ARN-365843) committed to delivering
            transparent, research-driven investment suggestions. We partner with individuals, families and businesses
            to design portfolios that are precise, resilient and aligned to long-term financial goals.
          </p>
          <p className="mt-4 text-gray-400 leading-relaxed">
            Our philosophy is simple: discipline outperforms speculation. Every recommendation is informed by
            data, governed by risk-management and tailored to where our clients are in their wealth journey.
          </p>

          <div className="grid sm:grid-cols-3 gap-4 mt-10">
            {[
              { icon: <Building2 />, title: "AMFI Registered", body: "ARN-365843 · Transparent distribution framework." },
              { icon: <Compass />, title: "Goal-Aligned", body: "Plans designed around your life, not the market." },
              { icon: <Globe2 />, title: "Pan-India + NRI", body: "Serving Indian residents and global NRI clients." },
            ].map((b, i) => (
              <div key={i} className="glass rounded-xl p-5 hover:border-[#D4AF37]/40 transition" data-testid={`about-pillar-${i}`}>
                <div className="text-[#D4AF37] mb-3">{b.icon}</div>
                <div className="font-display font-semibold text-white">{b.title}</div>
                <div className="text-sm text-gray-400 mt-1">{b.body}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
